import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import {
  IsDateString,
  IsNumber,
  IsOptional,
  IsString,
  MaxLength,
  Min,
} from 'class-validator';

/**
 * Body of PATCH /repair-payment/:id/payable (Repair Payables sheet).
 * Partial: a key that is absent leaves the column untouched. On the first
 * submit of a row with no Current Cost the API locks it at the calculated
 * cost, which the admin used to do by reading the row back first and echoing
 * every field (a lost-update window). Payment fields stay gated to the Labor
 * Coordinator, as on the crud PATCH.
 */
export class RepairPaymentPayableDto {
  @ApiPropertyOptional({ type: 'number', minimum: 0 })
  @Expose()
  @IsOptional()
  @IsNumber()
  @Min(0)
  currentCost?: number;

  @ApiPropertyOptional({ type: 'string', maxLength: 255 })
  @Expose()
  @IsOptional()
  @IsString()
  @MaxLength(255)
  check?: string;

  @ApiPropertyOptional({ type: 'string', format: 'date-time' })
  @Expose()
  @IsOptional()
  @IsDateString()
  paidDate?: string;
}
